import ListHeader from "@/common/components/ListHeader";
import Table from "@/common/components/Table";
import { TableIcon } from "lucide-react";
import { useAnpReports } from "../../hooks/useAnpReports";
import { useFilterParams } from "@/common/hooks/useFilterParams";
import { Mapper } from "@/common/services/mapper";
import { AnpReportsTransformer } from "../../services/anpReportsTransformer";
import { anpReportsDefaultColumns } from "../../constants/anpReportsDefaultColumns.constant";
import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import { defaultMeta } from "@/common/constants/defaultMeta.constant";

const AnpReportsList = () => {
  const { filterParams, setFilterParams } = useFilterParams();

  const {
    data: anpReports = [],
    meta = defaultMeta,
    isLoading: anpReportsIsLoading,
    error: anpReportsError = {} as any,
    refetch: refetchAnpReports,
  } = useAnpReports({
    filters: { page: Number(filterParams.page) || 1 },
    mapper: Mapper.mapWithTransformer({ transformer: AnpReportsTransformer.tableTransformer() }),
  });

  return (
    <div className="flex flex-col gap-6">
      <ListHeader
        Icon={<TableIcon className="w-10 h-10" strokeWidth={1} />}
        title="Tabelas ANP"
      />

      <ErrorMessageWrapper
        className="max-h-[calc(100vh-128px)]"
        statusCode={anpReportsError?.status}
        refetchFunction={refetchAnpReports}
      >
        <div className="h-[calc(100vh-128px)] flex flex-col gap-6">
          <Table
            columns={anpReportsDefaultColumns}
            isLoadingData={anpReportsIsLoading}
            page={Number(filterParams.page) || 1}
            rows={anpReports}
            totalPages={meta.total_pages}
            totalCount={meta.total}
            hasPagination
            setPage={(page) => setFilterParams((prev: any) => ({ ...prev, page }))}
            rowEmptyValue="--"
          />
        </div>
      </ErrorMessageWrapper>
    </div>
  );
};

export default AnpReportsList;
